import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
import { ReportService } from '../../service/report.service';
import { MatTableDataSource } from '@angular/material/table';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-energymeterreport',
  templateUrl: './energymeterreport.component.html'
})
export class EnergymeterreportComponent implements OnInit, OnChanges {

  // Property declaration
  tableHeight: number = 400;
  ReportData = [];
  @Input() FromDate: string;
  @Input() ToDate: string;
  @Input() MeterId: string;
  @Input() NodataFound: boolean;
  dataSource: any;
  IsShow: boolean = false;
  noDataMsg: string = '';
  errorMsg: string = '';
  displayedColumns = ['DateTime', 'ApperantPower', 'ActivePower', 'PowerFactor', 'ActiveEnergy', 'ReactiveEnergy', 'ApperantEnergy', 'MDI', 'Voltage', 'Current'];
  @Input() IsGetReportData: boolean = false;

  constructor(private reportservice: ReportService) { }

  ngOnInit(): void {


  }

  // Get Report Data
  GetReportData() {

    let newObj = {
      EnergymeterID: this.MeterId,
      FromDate: [formatDate(this.FromDate, 'dd/MM/yyyy', 'en')][0],
      ToDate: [formatDate(this.ToDate, 'dd/MM/yyyy', 'en')][0]
    };

    this.reportservice.GetReportData(newObj).subscribe(
      (result) => {
        if (result.length > 0) {
          this.ReportData = result;
          this.dataSource = new MatTableDataSource(this.ReportData);
          this.IsShow = true;
          this.noDataMsg = '';
        } else {
          this.IsShow = false;
          this.noDataMsg = 'No Data Found';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {

    if (this.NodataFound == true) {
      this.noDataMsg = 'No Data Found';
    }

    if (this.IsGetReportData == true) {
      this.GetReportData();
    }
    else{
      this.IsShow = false;
    }
  }

}
